import React from 'react';
import styled, { css } from 'styled-components';
import Basket from '@catalogo/ui-americanas-desktop-svg/pdp-basket.svg';
import Mundo from '@catalogo/ui-americanas-desktop-svg/airplane.svg';

const IconStyle = css`
  margin-right: 10px;
  fill: #fff;
  margin-bottom: 2px;
  height: auto;
`;

const BasketUI = styled(Basket)`
  ${IconStyle}
  width: 20.5px;
`;

const MundoUI = styled(Mundo)`
  ${IconStyle}
  width: 29px;
`;

MundoUI.displayName = 'MundoUI';

export const Icon = ({ isInternational }) =>
  isInternational ? <MundoUI className="buy-button-icon" /> : <BasketUI className="buy-button-icon" />;

export default Icon;
